<ng-container *ngIf="educationalSteps$ | async as educationalSteps; else spinner">
    <section class="nav">
        <app-navigation class="app-navigation" [educationalSteps]="educationalSteps"></app-navigation>
    </section>
</ng-container>

<ng-template #spinner>
    <app-spinner class="custom-spinner"></app-spinner>
</ng-template>
